'use strict';

var React = require('react'),
    Children = require('react/lib/ReactChildren'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    SidebarHeader = require('../molecules/SidebarHeader'),
    Container = require('./Container'),
    { PropTypes } = React;

require('./SidebarBody.less');

var SidebarBody = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node
  },

  getDefaultProps() {
    return {
      fillHeight: true
    };
  },

  className: 'SidebarBody',

  render() {
    return (
      <div className={this.getClassName()}>
        <SidebarHeader title={this.props.title}
                       subtitle={this.props.subtitle} />

        {Children.map(this.props.children, this.wrapInContainer)}
      </div>
    );
  },

  wrapInContainer(component) {
    if (component) {
      return (
        <Container context='Sidebar'>
          {component}
        </Container>
      );
    }
  }
});

module.exports = SidebarBody;


/** WEBPACK FOOTER **
 ** ./organisms/SidebarBody.jsx
 **/